import type { UserFlagsType } from '@/types/app-data/user.types'

export type SegmentUser = {
  userId: number
  fullName?: string
} & Pick<UserFlagsType, 'isIntakePt' | 'isLeadPt' | 'isTreatmentPt'>

export enum FeedEventSource {
  SIDEBAR = 'Sidebar',
  CHART = 'Chart'
}

export enum LeaveFeedEventDestination {
  PRESCRIPTION = 'Prescription',
  RESULTS = 'Results',
  RECORDS = 'Records',
  PROFILE = 'Profile'
}

export enum MemberEventSource {
  MEMBER_PROFILE = 'Member Profile',
  MEMBERS_LIST = 'Member’s List',
}
